<template>
  <div class="ApplicationLoginTimeout">
    <b-container class="content">
      <div class="icon-row">
        <img class="error-icon" src="@/assets/icon-timeout.png" />
      </div>
      <b-row>
        <b-col>
          <h2>Your session has timed out</h2>

          <button class="btn-link" type="button" @click="resumeApp">Resume application</button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'ApplicationLoginTimeout',
  methods: {
    resumeApp() {
      this.$emit('clicked')
    }
  }
}
</script>

<style lang="scss" scoped>
.ApplicationLoginTimeout {
  position: relative;
  top: $header-height;

  .content {
    margin: 0 auto 3rem;
    padding: 1rem 2rem 3rem;
    text-align: center;
    .icon-row {
      position: relative;
      width: 230px;
      height: 230px;
      background: $color-white;
      border-radius: 50%;
      margin: 5rem auto;
      .error-icon {
        width: 134px;
        height: auto;
        position: absolute;
        transform: translate(-50%, -50%);
        left: 50%;
        top: 50%;
      }
    }
    h2 {
      font-size: 28px;
    }
    .btn-link {
      font-size: 1.6rem;
    }
  }
}
</style>
